<template>
  <div class="border-radius mt-2 recent-pages__item bg-light-grey-600" :class="{'running-campaign': isRunningAbTesting, 'default-page': isDefault()}">
    <div class="recent-pages__row d-flex align-items-center justify-content-between">
      <component :is="notAllow || isRunningAbTesting ? 'div' : 'a'" :href="isGemPagesV7 ? editorV7Url : page.editUrl" class="d-flex flex-grow-1">
        <div class="recent-pages__img skeleton-light-grey-200 mr-12px" v-if="loadingDashboard"></div>
        <div class="recent-pages__img mr-2" v-else>
          <img v-if="isOriginalShopifyPage || page.isGpTemplate == false || page.gp_unlink == true" :src="require('@/core/assets/Shopify.jpg')" />
          <img v-else-if="thumbnail" :src="thumbnail" />
          <img v-else :src="require('@/core/assets/ThumbnailPlaceholder.jpg')" />
        </div>
        <div class="d-flex flex-column" v-if="loadingDashboard">
          <div class="recent-pages__loading-long skeleton-light-grey-200 mt-2"></div>
          <div class="recent-pages__loading-short skeleton-light-grey-200 mt-1"></div>
        </div>
        <div v-else class="d-flex flex-column align-items-start justify-content-center">
          <!-- heading -->
          <div class="d-flex align-items-center recent-pages__heading">
            <div class="d-flex align-items-center recent-pages__title mr-1">
              <div v-if="titleTooltip && isEllipsisTitleActive"  class="tool-tip d-flex align-items-center">
                <span class="tool-tip-value typo-medium">{{ titlePage }}</span>
              </div>
              <span 
                class="heading-h6-14-medium text-light-high content" 
                ref="title"
                @mouseenter="titleTooltip = true" @mouseleave="titleTooltip = false"
                :class="{'running-campaign': isRunningAbTesting}"
              >
                {{ titlePage }}
              </span>
            </div>
            <div v-if="isGemPagesV7">
              <div class="recent-pages__status mr-1" :class="pageStatusClassV7" v-if="pageStatusV7">
                <p class="recent-pages__status-text typo-paragraph12 typo-medium">{{pageStatusV7}}</p>
              </div>
            </div>
            <div class="d-flex" v-else>
              <div class="recent-pages__status mr-1" :class="pageStatusClass" v-if="pageStatus">
                <p class="recent-pages__status-text typo-paragraph12 typo-medium">{{pageStatus}}</p>
              </div>
              <div v-if="isRunningAbTesting" class="recent-pages__status campaign" @mouseenter="campaignTooltip = true" @mouseleave="campaignTooltip = false">
                <div v-if="campaignTooltip" class="tool-tip tool-tip-campaign d-flex align-items-center">
                  <span class="tool-tip-value typo-regular">{{ $t("page.campaign.tooltip") }}</span>
                </div>
                <p class="typo-paragraph12 typo-medium">{{ $t("page.status.campaign") }}</p>
              </div>
              <div v-else-if="isPublishScheduled && ['Product Page', 'Collection Page', 'Home Page'].includes(pageType[page.type])" class="recent-pages__status schedule">
                <p class="typo-paragraph12 typo-medium">{{ $t("page.status.scheduled") }}</p>
              </div>
              <div v-else-if="isNeedRepublishing && ['Product Page', 'Collection Page', 'Home Page'].includes(pageType[page.type])" class="recent-pages__status need-publish">
                <p class="typo-paragraph12 typo-medium">{{ $t("page.status.outdated") }}</p>
              </div>
              <div v-else-if="!page.isPublished && !isOriginalShopifyPage && ['Product Page', 'Collection Page', 'Home Page'].includes(pageType[page.type])" class="recent-pages__status draft">
                <p class="typo-paragraph12 typo-medium">{{ $t("page.status.draft") }}</p>
              </div>
            </div>
          </div>

          <!-- description -->
          <div v-if="isRunningAbTesting" class="recent-pages__desc d-flex align-items-center mt-1">
            <div class="recent-pages__campaign d-flex align-items-center">
              <div v-if="campaignDescTooltip" class="tool-tip tool-tip-campaign-desc d-flex align-items-center">
                <span class="tool-tip-value typo-regular">{{ $t("page.campaign.warning") }}</span>
              </div>
              <p class="recent-pages__campaign-desc paragraph-12-regular text-light-high" ref="ab" :class="{'is-tooltip': campaignDescTooltip }" @mouseenter="checkHoverTruncateABTestDesc" @mouseleave="campaignDescTooltip = false">
                {{ $t("page.campaign.warning") }}
              </p>
            </div>
            <a :href="`/analytics/experiments/${page.runningCampaignId}`" @click.stop class="recent-pages__campaign-link typo-paragraph12 typo-medium ml-half">{{ $t("page.campaign.action") }}</a>
          </div>
          <div class="d-flex align-items-center mt-1" v-else>
            <p class="recent-pages__type body-12-regular text-dark6">{{ pageType[page.type] }}</p>

            <span class="recent-pages__seperator"></span>

            <!-- Scheduled Published at -->
            <div class="recent-pages__schedule-publish d-flex align-items-center" v-if="isPublishScheduled">
              <p class="recent-pages__schedule-publish-at body-12-regular text-dark6">{{ schedulePublishAt }}</p>
            </div>

            <!-- Modified at -->
            <div class="recent-pages__modified d-flex align-items-center" v-if="isModifiedAt">
              <p class="recent-pages__modified-at body-12-regular text-ligh-low text-dark6 d-flex" v-if="!isOriginalShopifyPage">
                {{ $t("page.sort.modified") }} {{ lastModfiedTime }} 
              </p>
            </div>
          </div>
        </div>
      </component>
      <div class="d-flex justify-content-end flex-shrink-1 mr-2">
        <div 
          class="recent-pages__action-view-live d-flex align-items-center justify-content-center mr-1" 
          v-popover:tooltip.bottom="$t('generals.viewLivePage')" 
          v-if="showViewLiveCondition"
        >
          <div class="recent-pages__loading-action skeleton-light-grey-200" v-if="loadingDashboard">
            &nbsp;
          </div>
          <a :href="isOpenViewLive && page.viewliveUrl" target="_blank" class="page-item-tools-viewlive-button" v-else>
            <i class="icon icon-view typo-icon-20 text-light-high"></i>
          </a>
        </div>
        <div class="recent-pages__action-dropdown">
          <div class="recent-pages__loading-action skeleton-light-grey-200" v-if="loadingDashboard">
            &nbsp;
          </div>
          <PageItemDropdown v-else :page="page" recent-pages :not-allow="notAllow"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageItemDropdown from "@/core/shared/GpList/components/PageItemDropdown.vue";
import AbTestingTooltip from "@/core/components/AbTestingTooltip.vue";
import { TimeMaker } from "@/plugins";
import { mapGetters, mapState } from "vuex";
import Config from "@/config";
import { getThemeId } from "@/modules/Instant/utils";

export default {
  name: "RecentPageItem",
  components: {
    PageItemDropdown,
    AbTestingTooltip
  },
  props: {
    page: {
      type: [Object, Boolean]
    },
    loadingDashboard: {
      type: Boolean, 
      default: false
    }
  },
  data() {
    return {
      titleTooltip: false,
      campaignTooltip: false,
      campaignDescTooltip: false,
      themeId: null,
      pageThumbnail: '',
    }
  },
  computed: {
    ...mapGetters("account", {
      language: "displayLanguage"
    }),
    ...mapState("account", {
      permissions: "permissions"
    }),
    isRunningAbTesting() {
      return this.page.runningCampaignId > 0;
    },
    textDefault() {
      return {
        "Theme Product Template": this.$t("page.defaultShopifyTemplate"),
        "Theme Collection Template": this.$t("page.defaultShopifyTemplate"),
        "Theme Index Template": this.$t("page.defaultShopifyTemplate"),
        "Your first Homepage": this.$t("page.defaultShopifyTemplate")
      };
    },
    pageType() {
      return {
        "template-page": this.$t("page.landingPages1"),
        "template-index": this.$t("dashboard.homePage"),
        "template-product": this.$t("dashboard.productPage"),
        "template-collection": this.$t("dashboard.collectionPage"),
        "template-article": this.$t("dashboard.articlePage"),
        
        // V7 page types
        "GP_STATIC": this.$t("page.landingPages1"),
        "GP_INDEX": this.$t("dashboard.homePage"),
        "GP_PRODUCT": this.$t("dashboard.productPage"),
        "GP_COLLECTION": this.$t("dashboard.collectionPage"),
        "GP_ARTICLE": this.$t("dashboard.articlePage"),
      };
    },
    // isDisplayViewLive() {
    //   if(["Home Page"].includes(this.pageType[this.page.type])) {
    //     return this.isDefault() ? true : false;
    //   }
    //   return !["Product Page", "Collection Page"].includes(this.pageType[this.page.type]);
    // },
    isOpenViewLive() {
      if (["Landing Page", "Blog Post"].includes(this.pageType[this.page.type])) {
        if(!this.page.isPublished) return false;
      }
      if (this.page && this.page.viewliveUrl) return true;
      return false;
    },
    showViewLiveCondition() {
      if(!this.page.viewliveUrl) return false;
      if (["Landing Page", "Blog Post"].includes(this.pageType[this.page.type])) {
        return this.page.isPublished;
      }
      if (["Home Page"].includes(this.pageType[this.page.type])) {
        return this.isDefault();
      }
      return !["Product Page", "Collection Page"].includes(this.pageType[this.page.type])
    },
    isEllipsisTitleActive() {
      if (!this.$refs.title) return;
      return this.$refs.title.offsetWidth < this.$refs.title.scrollWidth;
    },
    pageStatusClass() {
      if(["Product Page", "Collection Page", "Home Page"].includes(this.pageType[this.page.type])) {
        if(this.isDefault()) return "default";
        return;
      }
      if(this.isPublishScheduled) return "schedule";
      if(this.isNeedRepublishing) return "need-publish";
      if(!this.page.isPublished) return "draft";
      return null;
    },
    pageStatus() {
      if(["Product Page", "Collection Page", "Home Page"].includes(this.pageType[this.page.type])) {
        if(this.isDefault()) return this.$t("generals.default");
        return;
      }
      if(this.isPublishScheduled) return this.$t("page.status.scheduled");
      if(this.isNeedRepublishing) return this.$t("page.status.outdated");
      if(!this.page.isPublished) return this.$t("generals.draft");
      return null;
    },
    pageStatusClassV7() {
      if(this.isDefault()) return 'default';
      return this.page.status === 'DRAFT' && 'draft';
    },
    pageStatusV7() {
      if(this.isDefault()) return this.$t("generals.default");
      return this.page.status === 'DRAFT' && this.$t("generals.draft");
    },
    isModifiedAt() {
      return ["Product Page", "Collection Page", "Home Page"].includes(this.pageType[this.page.type]) && !this.isPublishScheduled
      || ['Landing Page', 'Blog Post'].includes(this.pageType[this.page.type]) && (!this.isPublishScheduled || this.isNeedRepublishing)
    },
    isPublishScheduled() {
      if(!this.page.events) return false; 
      return (this.page.events.some(item => item.event == "schedule_publish")) 
    },
    isNeedRepublishing() {
      if(!this.page.isPublished) return false;
      if(this.page.lastAction) return this.page.lastAction == "pageSave";
      return false;
    },
    schedulePublishAt() {
      if(!this.isPublishScheduled) return null;
      const scheduleEvent = this.page.events.find(item => item.event == "schedule_publish");
      const scheduledDate = new TimeMaker(scheduleEvent.event_at).ago(this.language);
      return `${this.$t("page.sort.scheduled")} ${scheduledDate}`;
    },
    isOriginalShopifyPage() {
      return this.textDefault[this.page.title] ? true : false;
    },
    notAllow() {
      if (!this.page) {
        return true;
      }

      if (this.isOriginalShopifyPage) {
        return true;
      }

      switch (this.page.type) {
        case "template-page":
          return !this.permissions.subpages;
        case "template-index":
          return !this.permissions.homepages;
        case "template-product":
          return !this.permissions.productpages;
        case "template-collection":
          return !this.permissions.collectionpages;
        case "template-article":
          return !this.permissions.articlepages;
        default: 
          return false;
      }
    },
    thumbnail() {
      if (this.page.metaThumbnail) {
        return this.page.metaThumbnail;
      }
      const url = this.page.thumbnailUrl
      let fileExtension = this.getFileExtensionFromSource(url);
      if (!fileExtension || url.includes("ThumbnailPlaceholder")) {
        return require("@/core/assets/ThumbnailPlaceholder.jpg");
      }
      return `${url.slice(0, url.length - (fileExtension.length + 1))}_thumbnail.${fileExtension}`;
    },
    titlePage() {
      return this.textDefault[this.page.title] ?? this.page.title;
    },
    lastModfiedTime() {
      return new TimeMaker(this.page.updatedAt).ago(this.language);
    },
    isGemPagesV7() {
      return (this && this.shopInfo && this.shopInfo.isGemPagesV7) || window.___gemShopInfo.isGemPagesV7 || false;
    },
    editorV7Url() {
      return Config.getSetting("instantBaseURL") + `/editor/${this.themeId}/${this.page.id}?type=gempagesv7`;
    }
  },
  async created () {
    if (this.isGemPagesV7) {
      this.themeId = await getThemeId();
    }
  },
  methods: {
    layoutDefaultStatus() {
      return ["template-collection", "template-index", "template-product"].includes(this.page.type) ? true : false;
    },
    isDefault() {
      if (this.isGemPagesV7) {
        return this.page.default;
      }

      if (this.layoutDefaultStatus()) {
        return this.page.published ? true : false;
      }
    },
    checkHoverTruncateABTestDesc() {
      this.$nextTick(() => {
        if(this.$refs.ab.offsetWidth < this.$refs.ab.scrollWidth) this.campaignDescTooltip = true;
      })
    },
    getFileExtensionFromSource(src) {
      if (!src?.includes(".")) return undefined;
      const lastItem = src.split(".").pop();
      if (!lastItem) return undefined;
      const extension = lastItem.split("?").shift();
      return extension;
    },
  }
}
</script>
